<template>
  <div class="page flex-col">
    <div class="group_1 flex-col">
      <div class="box_1 flex-col">
        <div class="box_2 flex-col">
          <div class="section_1 flex-col"></div>
        </div>
      </div>
    </div>
    <div class="group_2 flex-col">
      <div class="image-wrapper_7 flex-row justify-between">
        <img
          class="image_1"
          referrerPolicy="no-referrer"
          src="https://jg-cust.obs.cn-east-3.myhuaweicloud.com/cust/src/assets/lanhu4/img/SketchPngc59577b8d55915831ed14ef0bc4080fed52c21cc430bcd99ca7557619e49717a.png"
        />
        <img
          class="image_2"
          referrerPolicy="no-referrer"
          src="https://jg-cust.obs.cn-east-3.myhuaweicloud.com/cust/src/assets/lanhu4/img/SketchPng463c5ac107c43ff69c0756954864ae2b8a1198faf2b301b7c6a5b2807c9e7194.png"
        />
      </div>
      <div class="image-wrapper_8 flex-row">
        <img
          class="image_6"
          referrerPolicy="no-referrer"
          src="https://jg-cust.obs.cn-east-3.myhuaweicloud.com/cust/src/assets/lanhu4/img/SketchPng914305435f1326a26839c6885b76b43ac09c7bdb3023a3ad5f2785bc391f5367.png"
        />
      </div>
      <div class="section_5 flex-row">
        <div class="block_1 flex-col">
          <span
            class="text_12">工商查询+AI拓客&nbsp;&nbsp;人群包DIY+大模型生成&nbsp;&nbsp;多元营销通道、精准触达</span>
          <span class="text_11">商用软件、企业服务、B2B平台全行业适用</span>
          <img
            class="image_4"
            referrerPolicy="no-referrer"
            src="https://jg-cust.obs.cn-east-3.myhuaweicloud.com/cust/src/assets/lanhu4/img/SketchPngdf25162a907c1f9c973f8a7451a3047752a0e56b07a7cbaf35c119dacaee0039.png"
          />
        </div>
        <div class="block_2 flex-col justify-between">
          <div class="image-wrapper_9 flex-row">
            <img
              class="image_7"
              referrerPolicy="no-referrer"
              src="https://jg-cust.obs.cn-east-3.myhuaweicloud.com/cust/src/assets/lanhu4/img/SketchPng6caaf6b8041cf45ffbd257b5d8c912dd120352c10ce00628f897cb7bdf9a72a4.png"
            />
            <img
              class="image_9"
              referrerPolicy="no-referrer"
              src="https://jg-cust.obs.cn-east-3.myhuaweicloud.com/cust/src/assets/lanhu4/img/SketchPng1f1c055218578c51d3e7e966c8b6e4b323a6da99e073fc40a5b57be4d5e4c233.png"
            />
            <img
              class="image_10"
              referrerPolicy="no-referrer"
              src="https://jg-cust.obs.cn-east-3.myhuaweicloud.com/cust/src/assets/lanhu4/img/SketchPngcc73d3a7cbe63099a2a92d17a8b20642a311d2988a480cc264fd975f2e019e2a.png"
            />
            <img
              class="image_11"
              referrerPolicy="no-referrer"
              src="https://jg-cust.obs.cn-east-3.myhuaweicloud.com/cust/src/assets/lanhu4/img/SketchPng5433bb3566dec51eb5406ac6e92f4a71ff984929378f369cf04282eb1957166d.png"
            />
            <img
              class="image_12"
              referrerPolicy="no-referrer"
              src="https://jg-cust.obs.cn-east-3.myhuaweicloud.com/cust/src/assets/lanhu4/img/SketchPng75c5a75f776622cba5d17e540583eb31764dc85d17ed12d66adf177f2535e544.png"
            />
            <img
              class="image_13"
              referrerPolicy="no-referrer"
              src="https://jg-cust.obs.cn-east-3.myhuaweicloud.com/cust/src/assets/lanhu4/img/SketchPng3e65bf82fe4664b3f6f411da73a09d4943c57f2c05f49556b5aeac50a348bd19.png"
            />
            <img
              class="image_8"
              referrerPolicy="no-referrer"
              src="https://jg-cust.obs.cn-east-3.myhuaweicloud.com/cust/src/assets/lanhu4/img/SketchPng7b9847b0d81243526292620ce3f558a17b5d8bfc6f8075c02ea63288eb6436e0.png"
            />
          </div>
          <div class="box_4 flex-col">
            <div class="section_4 flex-col"></div>
            <div class="image-text_1 flex-row justify-between">
              <img
                class="image_3"
                referrerPolicy="no-referrer"
                src="https://jg-cust.obs.cn-east-3.myhuaweicloud.com/cust/src/assets/lanhu4/img/SketchPngc59577b8d55915831ed14ef0bc4080fed52c21cc430bcd99ca7557619e49717a.png"
              />
              
            </div>
            <div class="text-wrapper_1 flex-col"  @click="emitLogin"><span class="text_1">立即领取限额优惠</span></div>
          </div>
        </div>
      </div>
<!--      <div class="box_5 flex-row">-->
<!--        <img-->
<!--          class="image_5"-->
<!--          referrerPolicy="no-referrer"-->
<!--          src="../assets/lanhu4/img/SketchPng362ae5fb3456308e0e7accecc995a06063ff33dfa9dc832a67cda5a67c5a6bdc.png"-->
<!--        />-->
<!--        <div class="section_2 flex-col">-->
<!--          <div class="group_4 flex-col"></div>-->
<!--          <span class="text_2">首页</span>-->
<!--        </div>-->
<!--        <span class="text_3">产品解决方案</span>-->
<!--        <span class="text_5">营销开放平台</span>-->
<!--        <span class="text_6">数据开放平台</span>-->
<!--        <span class="text_7">招商渠道</span>-->
<!--        <span class="text_8">关于极光数据</span>-->
<!--        <div class="text-wrapper_2 flex-col"><span class="text_9">登录</span></div>-->
<!--        <div class="text-wrapper_3 flex-col"><span class="text_10">免费试用</span></div>-->
<!--      </div>-->
      <div class="box_6 flex-col"></div>
      <div class="group_5 flex-row">

        <div class="box_7 flex-col"></div>
        <div class="box_8 flex-col"></div>
        <div class="box_9 flex-col"></div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      constants: {}
    };
  },
  methods: {
    emitLogin() {
      this.$emit("openLogin");
    }
  }
};
</script>
<style scoped lang="css" src="../assets/lanhu4/index.css"/>



// WEBPACK FOOTER //
// src/views/carousel-item.vue